var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"height":"100%"}},[_c('div',{staticClass:"ui-paper"},[_c('div',{staticClass:"sketch",class:{'animate': _vm.isAnimate }}),_c('div',{staticClass:"tool tool--pencil",class:{'animate': _vm.isAnimate }})])])}
var staticRenderFns = []

export { render, staticRenderFns }